import { createBrowserRouter, redirect } from "react-router-dom";
import { RootLayout } from "./root-layout";
import { isAuthenticated } from "@/lib/auth";

export const router = createBrowserRouter([
  {
    element: <RootLayout />,
    children: [
      {
        index: true,
        lazy: () => import("./landing"),
      },
      {
        path: "audit",
        lazy: () => import("./audit"),
      },
      {
        path: "migrate",
        loader: ({ request }) => {
          const url = new URL(request.url);
          // Allow access with session_id (post-checkout auto-auth)
          if (!isAuthenticated() && !url.searchParams.has("session_id")) {
            return redirect("/?auth=required");
          }
          return null;
        },
        lazy: () => import("./migrate"),
      },
      {
        path: "jobs",
        loader: () => {
          if (!isAuthenticated()) return redirect("/?auth=required");
          return null;
        },
        lazy: () => import("./jobs"),
      },
      {
        path: "result/:jobId",
        loader: () => {
          if (!isAuthenticated()) return redirect("/?auth=required");
          return null;
        },
        lazy: () => import("./result"),
      },
    ],
  },
]);
